import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { AppCasinoState, CasinoPageState } from 'src/domains/casino/state/AppCasino.state';
import { CasinoFilters } from 'src/domains/casino/webview/CasinoGames/casino-filters/CasinoFilters';
import { CasinoNavigationLoader } from './CasinoNavigationLoader';
import {
    SearchInputWrapper,
    SearchInput,
    SearchCloseButton,
    SearchAndFilterWrapper,
    SearchInputBox,
} from 'src/domains/casino/webview/CasinoGames/casino-filters/CasinoFilters.style';
import { ButtonIconOnly } from 'src/ui/components/button/icon-only/ButtonIconOnly';
import { useCommon } from 'src/domains/common/Common';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';

interface CasinoNavigationPropsType {
    casinoPageState: CasinoPageState;
    hideCategories: boolean;
}

export const CasinoNavigation = observer('CasinoNavigation', (props: CasinoNavigationPropsType) => {
    const { casinoPageState, hideCategories } = props;
    const common = useCommon();
    const appCasinoState = AppCasinoState.get(common);

    const languagesState = LanguagesState.get(common);

    const placeholder = languagesState.getTranslation('casino.search-bar.placeholder', 'Search For Games');
    const inputKey = `${casinoPageState.casinoSearchExt.isSearchOpen.toString()}`;

    if (casinoPageState.showCategoryLoader) {
        return <CasinoNavigationLoader hideCategories={props.hideCategories} />;
    }

    const { isSearchOpen, isDropdownOpen } = casinoPageState.casinoSearchExt;

    return (
        <SearchAndFilterWrapper
            isDropdownOpened={isDropdownOpen}
            isMiniGamesListDisplayed={appCasinoState.miniGamesListState.isGamesListDisplayed}
            ref={casinoPageState.setNavRef}
            data-test='sticky-bar'
        >
            <ButtonIconOnly
                appearance='primary'
                dataTest='casino-search-button'
                icon={isSearchOpen ? 'chevron-left' : 'search-icon'}
                onClick={casinoPageState.toggleSearchInput}
                size='medium'
            />

            <SearchInputWrapper
                isSearchOpen={isSearchOpen}
                data-test='search-input-wrapper'
            >
                <SearchInputBox isSearchOpen={isSearchOpen}>
                    <SearchInput
                        autoFocus={isSearchOpen}
                        key={inputKey}
                        onChange={casinoPageState.onInputChange}
                        placeholder={placeholder}
                        ref={casinoPageState.setInputRef}
                        type='search'
                        value={casinoPageState.searchInputValue}
                        data-test='casino-search-input'
                    />
                    <SearchCloseButton onClick={casinoPageState.clearQueryOrClose} />
                </SearchInputBox>
            </SearchInputWrapper>

            {hideCategories ? null : (
                <CasinoFilters
                    casinoPageState={casinoPageState}
                    isSearchOpen={isSearchOpen}
                />
            )}
        </SearchAndFilterWrapper>
    );
});
